const ArrayToArrayMatcher = (value, matchValue) => {
    if (matchValue && value) {
        matchValue = matchValue.split(',');

        try {
            value = JSON.parse(value);
        } catch (error) {
            if(value instanceof Array) {
                value = value;
            } else {
                value = value.split(',');
            }
        }

        // check the value existence in the Matcher values by looping through toMatch (customer vaues array)
        let toMatch = value.map(i => i.toLowerCase());
        for(let i = 0; i < toMatch.length; i++) {
            if(matchValue.some((matchV) => matchV.toLowerCase() === toMatch[i])) {
                return true;
            }
        }
        return false;
    }
}

module.exports.ArrayToArrayMatcher = ArrayToArrayMatcher